import {Button, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText, getAddressforMaps} from 'presentation/utils';
import {StyledAddressContainer, StyledContainer} from './styles';
import {HealthAddressSectionProps} from './types';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function HealthAddressSection({provider}: HealthAddressSectionProps) {
	const address = getAddressforMaps({
		address: provider.logradouro,
		district: provider.nmBairro,
		city: provider.nmCidade,
		state: provider.cdUf,
		zipCode: provider.cep,
	});

	const handleOpenGoogleMaps = () => openGoogleMaps(address.addressForMaps || '');

	return (
		<StyledContainer>
			<Typography variant="subtitle2" color="text.secondary">
				{guideDetails.address}
			</Typography>

			<Stack gap={1}>
				<StyledAddressContainer>
					<DataInfo
						removeItemTextMargin
						iconName="location-on-filled"
						secondaryText={
							<Fragment>
								{address.formattedAddress}
								{provider.dsComplEndereco ? (
									<Fragment>
										<br />
										<strong>{guideDetails.referencePoint}</strong>{' '}
										{formatText(provider.dsComplEndereco)}
									</Fragment>
								) : null}
							</Fragment>
						}
						listItemProps={{
							sx: {
								width: 'unset',
								padding: 0,
							},
						}}
					/>
					<Button onClick={handleOpenGoogleMaps} variant="outlined">
						{guideDetails.viewMap}
					</Button>
				</StyledAddressContainer>
			</Stack>
		</StyledContainer>
	);
}
